export default __webpack_public_path__ + "static/third-05ea4725a426f204e9bfffacf6a28ccc.png";